<template>
  <Container :keyword="filter" :action="() => _get()">
    <PageHeader
      :perPage="false"
      :title="$options.name"
      :filter="filter"
      :action="() => _get()"
    >
      <ButtonFilter :action="() => _trigger()" />
      <!-- <ButtonExcel :action="() => _createExcel()" /> -->
    </PageHeader>
    <DataTable
      :skeleton="filter.requested"
      :noData="!filter.requested && headers.total_insentif == 'Rp 0'"
      :show="!filter.requested && headers.total_insentif != 'Rp 0'"
      :filter="filter"
      :pagination="false"
      :format="style.table"
      :action="() => _get()"
    >
      <!-- TABLE HEADER -->
      <tr>
        <TableHead
          v-for="(row, i) in headers"
          :key="i"
          :value="i"
          :data="headers"
        />
      </tr>
      <!-- END OF TABLE HEADER -->
      <!-- DESC OF TABLE HEADER -->
      <tr>
        <TableHead
          v-for="(row, i) in headers"
          :key="i"
          :end="i"
          :value="row"
          :data="headers"
        />
      </tr>
      <!-- END OF DESC TABLE HEADER -->
      <tr>
        <TableSpace />
      </tr>
      <!-- TABLE DETAIL -->
      <template v-for="(row, i) in details">
        <!-- HEAD DETAIL DATA -->
        <tr :key="_keyName(i)" :style="style.detail_block">
          <td :colspan="col_length" style="">
            <h3 v-html="clearCase(row.name)" />
          </td>
        </tr>
        <!-- HEAD COP DATA -->
        <!-- COP DETAIL DATA -->
        <tr :key="_keyDetail(i)">
          <TableDetail
            :iteration="j"
            :key="_keyDetailHeader(j)"
            :value="detail_header"
            v-for="(detail_header, j) in _detailHeaders(row.data)"
          />
        </tr>
        <!-- END OF COP DETAIL DATA -->
        <!-- DETAIL DATA -->
        <tr v-for="(detail_data, j) in row.data" :key="_keyDetail(j + i)">
          <TableDetail
            :iteration="k"
            :key="_keyDetailHeader(k)"
            :value="detail_data[detail_header]"
            :format="style.detail"
            v-for="(detail_header, k) in _detailHeaders(row.data)"
          />
        </tr>
        <!-- END OF DETAIL DATA -->
        <!-- TOTAL OF ACHIEVEMENT -->
        <tr :key="_keyTotal(i)">
          <th colspan="2">Total</th>
          <th :style="style.total">{{ totals[i] | currency }}</th>
          <th colspan="2"></th>
        </tr>
        <!-- END OF ACHIEVEMENT -->
        <tr :key="_keyBlank(i)" v-if="i != Object.keys(details).pop()">
          <TableSpace />
        </tr>
      </template>
      <!-- END OF DETAIL -->
    </DataTable>
    <div class="print-only">
      <hr />
      <SignatureInsentif />
    </div>
    <FormFilter />
  </Container>
</template>

<script>
import helper from "@/assets/js/helper.js";
import TableHead from "./component/table-head.vue";
import TableDetail from "./component/table-detail.vue";
import TableSpace from "./component/table-space.vue";
import SignatureInsentif from "./component/signature-insentif.vue";
import FormFilter from "./modals/filter.vue";
import { mapState, mapActions } from "vuex";
import retur from "../../../../store/retur";
export default {
  name: "InsentifSalesman",
  components: {
    FormFilter,
    TableHead,
    TableSpace,
    TableDetail,
    SignatureInsentif,
  },
  mixins: [helper],
  data() {
    return {
      col_length: 1,
      headers: {},
      details: {},
      totals: {},
      style: {
        table: "table-no-break",
        detail: "bg-light",
        total: "text-align: right",
        detail_block:
          "text-align: center; background-color: #4d5e78; color: white",
      },
    };
  },
  computed: {
    ...mapState(["loading"]),
    ...mapState("insentif_salesman", {
      filter: (state) => state.filter,
      response: (state) => state.response,
      modal: (state) => state.modal,
    }),
  },
  methods: {
    ...mapActions("insentif_salesman", ["triggerModal", "getInsentifSalesman"]),
    _trigger() {
      return this.triggerModal("filter");
    },
    _keyName(i) {
      return i + "name";
    },
    _keyTotal(i) {
      return i + "total";
    },
    _keyDetail(i) {
      return i + "detail";
    },
    _keyDetailHeader(i) {
      return i + "detail_header";
    },
    _keyBlank(i) {
      return i + "none";
    },
    _detailHeaders(data) {
      return data.length > 0 ? Object.keys(data[0]) : [];
    },
    _get() {
      this.getInsentifSalesman().then((res) => {
        let details = res.data.details;
        this.headers = res.data.headers;
        this.details = res.data.details;
        this.totals = res.data.totals;
        this.col_length =
          details[Object.keys(details)[0]].data.length > 0
            ? Object.keys(details[Object.keys(details)[0]].data[0]).length
            : 1;
      });
    },
    _setHeaders(res) {
      if (res.headers) {
        this.headers = res.headers;
      }
    },
  },
  mounted() {
    this._get();
  },
  created() {},
};
</script>
<style scoped>
@media print {
  .print-only {
    display: block;
  }
}
@media screen {
  .print-only {
    display: none;
  }
}
</style>